import actions from '../actions/school';
import mutations from '../mutations/school';
import getters from '../getters/school';

const state = {
    errorMessage: '',
    successMessage: '',
    courseList: {
        list: [],
        actions: [],
        marks: []
    },
    course: {
        course: {
            multiContent: {
                contents: []
            }
        },
        action: {},
        mark: {}
    },
    myCourse: {
        course: {},
        action: {},
        mark: {}
    },
    mineCourse: {
        buy: false
    },
  schoolVersion: '',
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/school.js